export const REFRESH_TOKEN = 'refreshToken'
export const ACCESS_TOKEN = 'accessToken'
export const CAPTCHA_ACTIONS = {
  singIn: 'signin',
  signUp: 'signup',
  sendOtp: 'sendOtp',
  recoveryPassword: 'recoveryPass',
}
export const SITE_KEY = '6Le7gOwpAAAAALWPiSJmhs05pVPkHQZSXVx3rNNf'
